import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/competition-stacking/actions';
import Settings from './components/settings';
import UserMessagesDictionary from 'components/organisms/competition-stacking/dictionaries/UserMessagesDictionary';

class CompetitionStacking extends Component {
    onClick(use) {
        const {competitionType} = this.props;
        this.props.dispatch(Action.do('useCompetitionStacking', !use, competitionType));
    }

    render() {
        let {sportConfig, stacking, competitionType} = this.props;

        if (!sportConfig.isReady()) {
            return null;
        }

        return (
            <div className={`advanced-filter${stacking.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>
                        {UserMessagesDictionary.getCompetitionStackingDisableMessage(competitionType)}
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>
                        {UserMessagesDictionary.getCompetitionStackingEnableMessage(competitionType)}
                    </button>
                </div>

                <Settings />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {competitionStacking, sportConfig} = state;

    return {
        sportConfig,
        stacking: competitionStacking,
    };
}

export default connect(mapStatesToProps)(CompetitionStacking);
